/** Digits in a TOTP / email-OTP code (Better Auth is configured 6/30). */
export const MFA_CODE_LENGTH = 6;

/**
 * Lifetime of the `dorca_pending` cookie (~10 min per the proxy contract).
 * The challenge / forced-enrollment views arm a timer for this long and send
 * the user back to the sign-in form when it fires. This is the ONLY way the UI
 * can know the pending state died: `POST /api/auth/mfa/verify` answers a
 * deliberately neutral 401 for both "wrong code" and "expired", so a failed
 * verify must never be rendered as an expiry.
 */
export const MFA_PENDING_TTL_MS = 10 * 60 * 1000;

/** Seconds the "send code" button stays locked after an email-OTP send. */
export const MFA_OTP_RESEND_COOLDOWN_SECONDS = 60;
